import { Icon } from './Icon';

interface AchievementProps {
  label: string;
  detail: string;
}

export function Achievement({ label, detail }: AchievementProps): JSX.Element {
  return (
    <div className="achievement" role="status" aria-live="polite">
      <span className="achievement__spark"><Icon name="spark" /></span>
      <span><strong>{label}</strong><small>{detail}</small></span>
    </div>
  );
}
